import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, Title } from "@/components/UI";
import { ProviderSection } from "@/components/contacting";
import { useRefsContext } from "@/contexts/ref";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
export const PropertyProvider = () => {
    const isProject = useIsNewBuildProject();
    const { t } = useI18n();
    const { propertyProviderRef } = useRefsContext();
    return (_jsxs(Section, { ref: propertyProviderRef, children: [_jsx(Title, { variant: "section", title: isProject
                    ? t("contact.provider.project.property_provider")
                    : t("contact.provider.property_provider"), id: "propertyProvider" }), _jsx(ProviderSection, {})] }));
};
